import { Button, FilterCommon, ImportModal, ProjectLeaveModal, Table } from "@/components";
import getLocalStorage from "@/hooks/getLocalStorage";
import setLocalStorage from "@/hooks/setLocalStorage";
import {
  CREATE_TYPE,
  filtersJson,
  getMessageResponseType,
  handleMessagesAPI,
  PAGINATION_DEFAULT,
  PROJECT_LEAVE_SCREEN,
  TMS_ROLE_ADMIN,
  TMS_ROLE_HR,
  TMS_ROLE_HRM,
  toFixedNumber,
} from "@/utils";
import { mapState } from "vuex";
import ProjectLeaveDetail from "../ProjectLeaveDetail/ProjectLeaveDetail.vue";
const columns = [
  {
    title: "No.",
    dataIndex: "no",
    key: "no",
    scopedSlots: { customRender: "no" },
    width: 80,
  },
  {
    title: "Name",
    dataIndex: "fullNameStaff",
    key: "name",
    scopedSlots: { customRender: "name" },
    width: 300,
  },
  {
    title: "Division",
    dataIndex: "division",
    key: "division",
    width: 200,
  },
  {
    title: "Department",
    dataIndex: "department",
    key: "department",
    width: 200,
  },
  {
    title: "Total Leave Day (s)",
    dataIndex: "leaveDay",
    key: "leaveDay",
    customRender(value) {
      return toFixedNumber(value, 3);
    },
    width: 200,
    align: "right",
  },
  {
    title: "Used",
    dataIndex: "used",
    key: "used",
    customRender(value) {
      return toFixedNumber(value, 3);
    },
    width: 200,
    align: "right",
  },
  {
    title: "Expired",
    dataIndex: "expired",
    key: "expired",
    customRender(value) {
      return toFixedNumber(value, 3);
    },
    width: 200,
    align: "right",
  },
  {
    title: "Remaining",
    dataIndex: "remaining",
    key: "remaining",
    customRender(value) {
      return toFixedNumber(value, 3);
    },
    width: 200,
    align: "right",
  },
];

const EMPLOYEE_ID_KEY = "employeeIdActive";
export default {
  name: "ProjectLeave",
  components: {
    FilterCommon,
    Button,
    Table,
    ProjectLeaveModal,
    ImportModal,
    ProjectLeaveDetail,
  },
  data() {
    return {
      dataFilterDefault: {},
      columns,
      visibleModal: false,
      visibleModalImport: false,
      filter: PAGINATION_DEFAULT,
      actionType: null,
      PROJECT_LEAVE_SCREEN,
      loadingDownload: false,
      loading: false,
      filterList: filtersJson[PROJECT_LEAVE_SCREEN],
      viewAllProjectLeaveByEmployee: false,
      employeeIdActive: getLocalStorage(EMPLOYEE_ID_KEY) ?? null,
    };
  },
  computed: {
    ...mapState({
      projectLeaveList: (state) => state.projectLeave.projectLeaveList,
      pages: (state) => state.projectLeave.pages,
      userInfo: (state) => state.user.userInfo,
    }),
    checkShowAction() {
      const {
        userInfo: { roles },
      } = this;
      return roles?.some((role) => [TMS_ROLE_HR, TMS_ROLE_HRM, TMS_ROLE_ADMIN].includes(role));
    },
    checkShowProjectLeave() {
      return !this.employeeIdActive;
    },
  },
  watch: {
    filter() {
      this.getProjectLeaveList();
    },
  },
  mounted() {
    this.getProjectLeaveList();
  },
  methods: {
    async getProjectLeaveList() {
      this.$store.dispatch("user/loadingRequest");
      try {
        await this.$store.dispatch("projectLeave/getProjectLeaveList", this.filter);
      } catch (error) {
        handleMessagesAPI(error.response.data);
      } finally {
        this.$store.commit("user/RESET_LOADING");
      }
    },
    handleFilter(filter) {
      this.filter = { ...this.filter, ...filter, page: 1 };
    },
    handleAddNew() {
      this.visibleModal = true;
      this.actionType = CREATE_TYPE;
    },
    handleImport() {
      this.visibleModalImport = true;
    },
    onCancel() {
      this.visibleModal = false;
      this.visibleModalImport = false;
    },
    handleViewDetail(id) {
      this.employeeIdActive = id;
      this.viewAllProjectLeaveByEmployee = true;
      setLocalStorage(EMPLOYEE_ID_KEY, id);
    },
    onBack() {
      this.viewAllProjectLeaveByEmployee = false;
      this.employeeIdActive = null;
      localStorage.removeItem(EMPLOYEE_ID_KEY);
    },
    handleChangePagination(payload) {
      this.filter = { ...this.filter, ...payload };
    },
    async downloadTemplate() {
      this.loadingDownload = true;
      try {
        const res = await this.$store.dispatch("projectLeave/downloadTemplate");
        handleMessagesAPI(res);
      } catch (error) {
        const errorObject = await getMessageResponseType(error);
        handleMessagesAPI(errorObject);
      } finally {
        setTimeout(() => {
          this.loadingDownload = false;
        }, 500);
      }
    },
    async onImport(values) {
      try {
        this.loading = true;
        const res = await this.$store.dispatch("projectLeave/importProjectLeave", values);
        handleMessagesAPI(res);
        const { code } = res?.headers;
        if (code == 200) {
          this.onCancel();
          this.getProjectLeaveList();
        }
      } catch (error) {
        const errorObject = await getMessageResponseType(error);
        handleMessagesAPI(errorObject);
      } finally {
        this.loading = false;
      }
    },
  },
};
